/* Sevine Dumont · account-drawer (08-10): openen/sluiten, tabbladen, recently viewed + favourites, link kopiëren. */
(function () {
  var root = document.getElementById('SdAccount');
  if (!root || root.dataset.ready) return; root.dataset.ready = '1';
  var RECENT = 'sd-recent', WISH = 'sd-wishlist', lastFocus = null, loaded = false;

  function read(key) { try { var l = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
  function write(key, l) { try { localStorage.setItem(key, JSON.stringify(l)); } catch (e) {} }

  /* Productpagina bezocht → onthouden (max. 10, nieuwste eerst) */
  var p = document.querySelector('sd-p1-product[data-handle]');
  if (p) { var h = p.dataset.handle, l = read(RECENT).filter(function (x) { return x !== h; }); l.unshift(h); write(RECENT, l.slice(0, 10)); }

  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var loc = document.documentElement.lang || 'en';
  function money(cents) { try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2); } }
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function card(handle) {
    return fetch(base + 'products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d) return '';
      var img = d.featured_image ? (d.featured_image.indexOf('?') > -1 ? d.featured_image + '&width=300' : d.featured_image + '?width=300') : '';
      var t = document.createElement('span'); t.textContent = d.title;
      return '<li class="sd-acc__item"><a href="' + d.url + '"><span class="sd-acc__item-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="300" height="375">' : '') +
        '</span><span class="sd-acc__item-title">' + t.innerHTML + '</span><span class="sd-acc__item-price">' + money(d.price) + '</span></a></li>';
    }).catch(function () { return ''; });
  }
  function fill(list, handles, wrapToggle, emptyEl) {
    if (!list) return;
    if (!handles.length) { list.innerHTML = ''; if (wrapToggle) wrapToggle.hidden = true; if (emptyEl) emptyEl.hidden = false; return; }
    Promise.all(handles.slice(0, 8).map(card)).then(function (html) {
      html = html.filter(Boolean); list.innerHTML = html.join('');
      if (wrapToggle) wrapToggle.hidden = html.length === 0;
      if (emptyEl) emptyEl.hidden = html.length > 0;
    });
  }
  function load() {
    var cur = p ? p.dataset.handle : null;
    fill(root.querySelector('[data-sd-acc-recent-list]'), read(RECENT).filter(function (x) { return x !== cur; }), root.querySelector('[data-sd-acc-recent]'));
    fill(root.querySelector('[data-sd-acc-fav-list]'), read(WISH), null, root.querySelector('[data-sd-acc-fav-empty]'));
  }

  function tab(name) {
    root.querySelectorAll('[data-sd-acc-tab]').forEach(function (t) { t.hidden = t.getAttribute('data-sd-acc-tab') !== name; });
    root.querySelectorAll('[data-sd-acc-tabbtn]').forEach(function (b) { var on = b.getAttribute('data-sd-acc-tabbtn') === name; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    var body = root.querySelector('.sd-acc__body'); if (body) body.scrollTop = 0;
  }
  function open(name) {
    lastFocus = document.activeElement;
    root.hidden = false; root.setAttribute('aria-hidden', 'false');
    tab(name || 'foryou'); load();
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    document.body.classList.add('sd-acc-lock');
    var c = root.querySelector('.sd-acc__close'); if (c) c.focus({ preventScroll: true });
  }
  function close() {
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sd-acc-lock');
    setTimeout(function () { root.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    if (location.hash === '#account') history.replaceState(null, '', location.pathname + location.search);
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-sd-account-open]');
    if (o) { e.preventDefault(); var d = document.querySelector('[data-sd-hdr-close]'); if (d && o.closest('.sd-hdr-m, [id^="SdHdrDrawer"]')) d.click(); open(o.getAttribute('data-sd-account-open') || 'foryou'); return; }
    if (e.target.closest('[data-sd-account-close]')) { e.preventDefault(); close(); return; }
    var b = e.target.closest('[data-sd-acc-tabbtn]'); if (b) { tab(b.getAttribute('data-sd-acc-tabbtn')); return; }
    var cp = e.target.closest('[data-sd-acc-copy]');
    if (cp) {
      var inp = cp.parentNode.querySelector('input'); var txt = inp ? inp.value : '';
      var done = function () { cp.classList.add('is-copied'); cp.setAttribute('aria-label', cp.dataset.copied || 'Copied'); };
      if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done).catch(function () { inp.select(); document.execCommand('copy'); done(); });
      else { inp.select(); document.execCommand('copy'); done(); }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
  if (location.hash === '#account') open('foryou');
})();
